module.exports = __webpack_public_path__ + "static/media/Edison_Traditinoal_at_Ivory_Ridge_1.896673f9.jpg";